import { Box, Grid, Paper } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { SVGS } from '@/assets/svgs'
import InfoSlideView from './InfoSlideView'
import { RBox } from '../__styled'
import colors from '@/styles/colors'

const SLIDE_DATA = [
  {
    icon: SVGS.TabPattern,
    title: 'Pattern Design',
    description:
      'Create intricate patterns with precision tools. Snap to grids, customize colors, and export production-ready files instantly.',
  },
  {
    icon: SVGS.TabQuilt,
    title: 'Quilt Design',
    description:
      'Design stunning patterns with intelligent templates. Mix fabrics, preview layouts, and share designs with your community.',
  },
  {
    icon: SVGS.TabAlbum,
    title: 'Collections',
    description:
      'Organize your creative work into beautiful collections. Showcase your portfolio and discover inspiration from other designers.',
  },
  {
    icon: SVGS.TabGallery,
    title: 'Gallery Design',
    description:
      'Build professional galleries in minutes. Collaborate with others, get feedback, and turn your designs into products.',
  },
]

const InfoSliderView = () => {
  const [currentPage, setCurrentPage] = useState(0)
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentPage((prev) => (prev == SLIDE_DATA.length - 1 ? 0 : prev + 1))
    }, 4000) // Adjust the interval time as needed

    return () => clearInterval(intervalId)
  }, [])

  return (
    <Box
      sx={{
        width: '100%',
        height: '280px',
        background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%)',
        borderRadius: '20px',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        overflow: 'hidden',
        position: 'relative',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          border: '1px solid rgba(255, 255, 255, 0.12)',
        },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '32px',
          left: '0px',
          width: '4px',
          height: '60px',
          background:
            'linear-gradient(180deg, #ff0080 0%, #ff8c00 20%, #40e0d0 40%, #4169e1 60%, #9370db 80%, #ff1493 100%)',
          zIndex: 10,
          borderRadius: '0px 4px 4px 0px',
          boxShadow: '0 0 20px rgba(255, 0, 128, 0.6), 0 0 40px rgba(64, 224, 208, 0.4)',
        }}
      />
      <Grid container spacing={2} direction='row' wrap='nowrap'>
        <Grid item sx={{ flex: '0 0 auto', width: '100%' }}>
          <InfoSlideView
            icon={SLIDE_DATA[currentPage].icon}
            title={SLIDE_DATA[currentPage].title}
            description={SLIDE_DATA[currentPage].description}
          />
        </Grid>
      </Grid>

      <RBox sx={{ alignItems: 'center', gap: '8px', justifyContent: 'center', pb: 2 }}>
        {SLIDE_DATA.map((item, index) => {
          const selected = index == currentPage
          return (
            <Box
              key={`${index}`}
              sx={{
                borderRadius: '12px',
                width: selected ? '32px' : '8px',
                height: '8px',
                background: selected
                  ? 'linear-gradient(90deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 100%)'
                  : 'rgba(255, 255, 255, 0.25)',
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                boxShadow: selected ? '0 2px 8px rgba(255, 255, 255, 0.3)' : 'none',
                cursor: 'pointer',
                '&:hover': {
                  background: selected
                    ? 'linear-gradient(90deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 100%)'
                    : 'rgba(255, 255, 255, 0.4)',
                },
              }}
            ></Box>
          )
        })}
      </RBox>
    </Box>
  )
}

export default InfoSliderView
